var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg54(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_91688)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95116 21.5008C4.188 21.5008 3.56934 22.1195 3.56934 22.8827V23.0937H17.8587V21.5008H4.95116ZM18.5619 23.7969V24.5H2.16309V22.8827C2.16309 21.3429 3.41135 20.0946 4.95116 20.0946H19.265V23.7969H18.5619Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.265 4.9827V21.5008H7.41163V9.01032L19.265 4.9827ZM8.81788 10.0177V20.0946H17.8588V6.94574L8.81788 10.0177Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83942 9.88435L21.3848 4.2624L21.8373 5.59388L5.29184 11.2158L4.83942 9.88435Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6602 7.95125V3.35253H14.0664V7.95125H12.6602Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6602 18.0985V14.7494H14.0664V18.0985H12.6602Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7127 3.40691H11.4139V2.00066H15.7127V3.40691Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96455 1.90625C8.52469 1.90625 8.1681 2.26284 8.1681 2.7027C8.1681 3.14256 8.52469 3.49916 8.96455 3.49916H10.0143C10.4541 3.49916 10.8107 3.14257 10.8107 2.7027C10.8107 2.26284 10.4541 1.90625 10.0143 1.90625H8.96455ZM6.76185 2.7027C6.76185 1.48619 7.74804 0.5 8.96455 0.5H10.0143C11.2308 0.5 12.217 1.48619 12.217 2.7027C12.217 3.91922 11.2308 4.90541 10.0143 4.90541H8.96455C7.74804 4.90541 6.76185 3.91922 6.76185 2.7027Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_91688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg54);
export default __webpack_public_path__ + "static/media/54.1d24511e86602bfed2180200080a4ec0.svg";
export { ForwardRef as ReactComponent };